const { handleError, handleResponse, api } = require("./baseApi");
const api_config = require("./api_config");

const EXTEND_URL = "/customers/v1";

function getCustomerApi(email) {
  return api
    .get(EXTEND_URL, {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
      params: {
        email,
        merchantCode: `${api_config.x_merchant_code}`
      }
    })
    .then(handleResponse)
    .catch(handleError);
}

function getCustomersApi(email) {
    return api
        .get(EXTEND_URL, {
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
            params: {
                email
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

function createCustomerApi(email, merchantCode, programmeCode) {
    return api
        .post(EXTEND_URL, {email, merchantCode, programmeCode}, {
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
        })
        .then(handleResponse)
        .catch(handleError);
}


function getCustomerForMerchantApi(email, merchantCode) {
    return api
        .get(EXTEND_URL, {
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
            params: {
                email,
                merchantCode
            }
        })
        .then(handleResponse)
        .catch(handleError);
}

module.exports = { getCustomerApi, getCustomerForMerchantApi, getCustomersApi, createCustomerApi };
